import {Vue} from "ui.vue";
import CitrusProductSlider from "./component/App.vue";

Vue.component("CitrusProductSlider", CitrusProductSlider);
